/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "hpLambdaNotifyUserOfEventApi",
            "endpoint": "https://e4316rvhz3.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        },
        {
            "name": "hpLambdaPublicQueryApi",
            "endpoint": "https://7862sommcj.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ru25bibpdvabjc7e7saizleby4.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-nup76dlexrbajeeoqfmlsbbayi"
};


export default awsmobile;
